export default __webpack_public_path__ + "static/banner-marketing-d566a3cfdc9eecb1209cd90a2a7ea188.svg";